import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Shipment } from '../../../../@posturinn/client-react';
import useLocations from '../../../../hooks/useLocations';
import { ReactComponent as IconNoShipment } from '../../../../icons/new-product.svg';
import { IShipmentPagination } from '../../../../interfaces/reducers/shipmentsReducer';
import MyShipmentsTileLoader from '../../../base/misc/myShipmentsTileLoader';
import Pagination from '../../../search/searchLandingPage/searchResults/pagination';
import ShipmentCard from '../shipmentCard';
import * as StyledShipmentList from './shipmentList.styles';

interface Props {
	shipments: IShipmentPagination;
	delivered: boolean;
	paginationCount: number;
	maxPerPage: number;
	changePage: any;
	includeHidden: boolean;
}

const ShipmentList: FC<Props> = ({ shipments, paginationCount, delivered, changePage, includeHidden }: Props) => {
	const { t } = useTranslation('myShipments');
	const { locations, locationsLoading } = useLocations();

	return (
		<>
			{shipments.loading &&
				[...Array(4)].map((_key, index) => (
					<div key={index} style={{ marginBottom: '2rem' }}>
						<MyShipmentsTileLoader />
					</div>
				))}
			{!shipments.loading &&
				shipments.results[paginationCount] &&
				shipments.results[paginationCount].length === 0 &&
				!shipments.error && (
					<StyledShipmentList.ShipmentCard simpleIcon blue>
						<IconNoShipment />
						{t('page-overview.noShipmentsFound')}
					</StyledShipmentList.ShipmentCard>
				)}
			{!shipments.loading &&
				!locationsLoading &&
				locations &&
				shipments.results[paginationCount] &&
				shipments.results[paginationCount].map((shipment: Shipment, index) => (
					<ShipmentCard
						key={shipment.id}
						shipment={shipment}
						locations={locations}
						delivered={delivered}
						page={paginationCount}
						shipmentIndex={index}
						includeHidden={includeHidden}
					/>
				))}

			{shipments.totalPageCount > 1 && (
				<Pagination numberOfGroups={shipments.totalPageCount} onChange={val => changePage(val, delivered)} />
			)}
		</>
	);
};

export default ShipmentList;
